import { noop } from 'lodash';
import { CardText } from 'reactstrap';
import Swal, { SweetAlertInput, SweetAlertResult } from 'sweetalert2';
import withReactContent, { ReactSweetAlertOptions } from 'sweetalert2-react-content';

const ActionSwal = withReactContent(Swal);

interface SwalProps extends ReactSweetAlertOptions {
  title?: string;
  text?: string;
  onConfirmed?: (result: SweetAlertResult) => Promise<void> | void;
  confirmButtonText?: string;
  onPreConfirm?: (confirmed: any) => Promise<unknown> | void;
  input?: 'file' | SweetAlertInput;
  inputLabel?: string;
}

const ConfirmDangerousActionSwal = ({
  text,
  confirmButtonText,
  onConfirmed,
  onPreConfirm,
  title,
  ...props
}: SwalProps) => ActionSwal.fire({
  title,
  text,
  position: 'center',
  icon: 'warning',
  allowEnterKey: false,
  showLoaderOnConfirm: Boolean(onPreConfirm),
  customClass: {
    // cancelButton: 'swal2-cancel mx-1 px-3',
    // confirmButton: 'swal2-confirm px-3'
    title: 'text-darkwash',
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-light ms-1'
    // cancelButton: 'btn btn-outline-danger ms-1'
  },
  buttonsStyling: false,
  showCancelButton: true,
  // cancelButtonColor: '#1f3864',
  // confirmButtonColor: '#e74c3c',
  confirmButtonText: confirmButtonText ?? 'Proceed',
  preConfirm: onPreConfirm ?? noop,
  html: (
    <CardText className={'text-black-50'}>{text}</CardText>
  ),
  ...(props && {
    ...props
  })
}).then((value) => {
  if (onConfirmed instanceof Function) {
    return onConfirmed(value);
  }
  return value;
});

export default ConfirmDangerousActionSwal;
